// modules/estrategias/vejez/api/VejezAPI.js
import axiosClient from "../../../inicio/api/axiosClient";

export const getPersonas = (params) => axiosClient.get("/vejez", { params });
export const getPersonaById = (id) => axiosClient.get(`/vejez/${id}`);
export const createPersona = (data) => axiosClient.post("/vejez", data);
export const updatePersona = (id, data) => axiosClient.put(`/vejez/${id}`, data);
export const deletePersona = (id) => axiosClient.delete(`/vejez/${id}`);
export const exportarExcelVejez = (params) => axiosClient.get("/vejez/exportar", { params, responseType: "blob" });

export const subirConsentimientoVejez = (id, archivo) => {
  const formData = new FormData();
  formData.append("archivo", archivo);
  return axiosClient.post(`/vejez/${id}/consentimiento`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const eliminarConsentimientoVejez = (id) => axiosClient.delete(`/vejez/${id}/consentimiento`);

// Alias usados por offline/vejezOffline.js
export const crearPersonaAPI = createPersona;
export const actualizarPersonaAPI = updatePersona;
